const deliverablesQcKeyAliases = [
  { canonical: 'SRT_File_Available', legacy: 'srT_File_Available' },
  { canonical: 'SRT_Sync', legacy: 'srT_Sync' },
  { canonical: 'Watermark', legacy: 'watermark' },
] as const;

export const normalizeDeliverablesQcRows = (rows: any[] = []) => {
  if (!Array.isArray(rows)) return [];

  return rows.map((row) => {
    if (!row || typeof row !== 'object' || Array.isArray(row)) {
      return row;
    }

    const normalizedRow = { ...row };

    deliverablesQcKeyAliases.forEach(({ canonical, legacy }) => {
      const legacyValue = normalizedRow[legacy];

      if (legacyValue !== undefined && legacyValue !== null && legacyValue !== '') {
        normalizedRow[canonical] = legacyValue;
      } else if (
        normalizedRow[canonical] === undefined &&
        legacyValue !== undefined
      ) {
        normalizedRow[canonical] = legacyValue;
      }

      delete normalizedRow[legacy];
    });

    return normalizedRow;
  });
};

export const normalizeDeliverablesQcElementValue = (elementValue: string) => {
  if (!elementValue?.includes('DynamicTable|')) {
    return elementValue;
  }

  try {
    const rows = JSON.parse(elementValue.split('DynamicTable|')[1] || '[]');
    return `DynamicTable|${JSON.stringify(normalizeDeliverablesQcRows(rows))}`;
  } catch {
    return elementValue;
  }
};
